import React from "react";
import { Box } from "@mui/material";

import { displayFullName } from "../../../../utilities/formatters";
import RenderDate from "../../../Common/Date/RenderDate";

const QuestionnaireDetails = ({
    requester,
    areaOfWork = null,
    organisation = null,
    startDate = null,
    endDate = null,
    isActive = false,
}) => {
    const displayJobRole = requester?.jobRole || "Not specified";
    const displayAreaOfWork = areaOfWork?.name || "Not specified";
    const displayOrganisation = organisation?.name || "Not specified";

    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Name</dt>
                <dd>{displayFullName(requester)}</dd>
            </dl>

            <dl className="row-data">
                <dt>Job role</dt>
                <dd>{displayJobRole}</dd>
            </dl>

            <dl className="row-data">
                <dt>Area of work</dt>
                <dd>{displayAreaOfWork}</dd>
            </dl>

            <dl className="row-data">
                <dt>Organisation</dt>
                <dd>{displayOrganisation}</dd>
            </dl>
            <dl className="row-data">
                <dt>Distributed</dt>
                <dd>{!!startDate && <RenderDate date={startDate} />}</dd>
            </dl>
            <dl className="row-data">
                <dt>Return by</dt>
                <dd>
                    {" "}
                    {!!endDate && (
                        <RenderDate date={endDate} colourise={isActive} />
                    )}
                </dd>
            </dl>
        </Box>
    );
};

export default React.memo(QuestionnaireDetails);
